import { render, staticRenderFns } from "./verify-1.vue?vue&type=template&id=2ea0fc0c&scoped=true"
import script from "./verify-1.vue?vue&type=script&lang=js"
export * from "./verify-1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea0fc0c",
  null
  
)

export default component.exports